<template>
    <div class="market-item lineOdd-list">
        <div class="p-2">
            <span class="market-name">{{odd.name}} <i class="os-icon os-icon-info"></i></span>

            <span class="pull-right">
                <a href="javascript:;" @click="changeMode()">{{ t.show_more }}</a>
            </span>
        </div>
        <div class="px-4" v-show="mode === 1">
            <div class="row">
                <div class="col-5">
                    <div class="col-12 text-center team-name">
                        {{ match.competitor.oneName }}
                    </div>
                    <VueSlideBar
                            :paddingless="true"
                            v-model="homeSlider.value"
                            :data="homeSlider.data"
                            :range="homeSlider.range"
                            :labelStyles="{ color: '#4a4a4a', backgroundColor: '#4a4a4a' }"
                            :processStyle="{ backgroundColor: '#d8d8d8' }"
                            @callbackRange="callbackHomeRange">
                        <template slot="tooltip" slot-scope="tooltip">
                            <div class="betslider"></div>
                        </template>
                    </VueSlideBar>
                </div>
                <div class="col-5">
                    <div class="col-12 text-center team-name">{{ match.competitor.twoName }}</div>
                    <VueSlideBar
                            :paddingless="true"
                            v-model="awaySlider.value"
                            :data="awaySlider.data"
                            :range="awaySlider.range"
                            :labelStyles="{ color: '#4a4a4a', backgroundColor: '#4a4a4a' }"
                            :processStyle="{ backgroundColor: '#d8d8d8' }"
                            @callbackRange="callbackAwayRange">
                        <template slot="tooltip" slot-scope="tooltip">
                            <div class="betslider"></div>
                        </template>
                    </VueSlideBar>
                </div>
                <div class="col-2">
                    <div class="odd-labels">
                        <div class="odd-market w100" style="border: none">
                            {{ this.homeSlider.value+'-'+this.awaySlider.value }}
                            <Selection v-if="currentSelection" :selectedOdds="selectedOdds" :odd.sync="currentSelection" :match="match" :market="currentMarket"></Selection>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="odd-labels full-block" v-show="mode === 2">
            <div v-for="selection in sortAByKey(odd.odd, 'order')"
                 class="odd-market text-center"
                 :class="(findByKey(selectedOdds, 'oddId', selection.id)) ? 'active' : 'disable' ">
                <span v-tooltip="selection.outcome">{{selection.outcome}}</span>

                <Selection :selectedOdds="selectedOdds" :odd.sync="selection" :match="match" :market="odd"></Selection>
            </div>
        </div>
    </div>
</template>

<script>
    import Selection from "../../selection";
    export default {
        name: "score",
        props: ['odd', 'match', 'selectedOdds'],
        components: {Selection},
            data () {
                return {
                    currentSelection: null,
                    t: this.$root.t,
                    mode: 1,
                    homeRangeValue: 0,
                    awayRangeValue: 0,
                    homeSlider: {
                        value: 1,
                        data: [

                        ],
                        range: [

                        ]
                    },
                    awaySlider: {
                        value: 1,
                        data: [

                        ],
                        range: [

                        ]
                    },
                    currentMarket: {}
                }
            },
            mounted () {

                setTimeout(() => {

                    for(var im=0; im<=6; im++){

                        this.homeSlider.value = 0;
                        this.awaySlider.value = 0;
                        this.homeSlider.data.push(im)
                        this.homeSlider.range.push({label: ''+im})
                        this.awaySlider.data.push(im)
                        this.awaySlider.range.push({label: ''+im})

                    }

                }, 500)
            },
            watch: {
                'homeSlider.value' (){

                    this.findCorrectMarket()
                },
                'awaySlider.value' () {
                    this.findCorrectMarket()
                }
            },
            methods: {
                changeMode () {
                    this.mode = (this.mode === 1) ? 2 : 1;

                },
                callbackHomeRange (val) {
                    if(val)
                        this.homeRangeValue = val.label;
                },
                callbackAwayRange (val) {

                    if(val)
                        this.awayRangeValue = val.label;
                },
                findCorrectMarket()
                {
                    this.currentSelection = null;
                    for(var mid in this.odd.odd){

                        if(this.odd.odd[mid].outcome == this.homeSlider.value+'-'+this.awaySlider.value
                        || this.odd.odd[mid].outcome == this.homeSlider.value+':'+this.awaySlider.value
                        ){
                            this.currentMarket = this.odd;
                            this.currentSelection = this.odd.odd[mid];
                        }

                    }
                }
            },
        }
</script>

<style scoped>
    .team-name {
        font-weight: bold;
    }
</style>


// WEBPACK FOOTER //
// src/components/sportsbook/market/template/score.vue